"use client"
import React, { useState } from 'react'
import Link from "next/link"
import Paging from "@/components/common/paging/Paging"
import { NEXT_PAGE_NUMBER } from "@/constants/appConstant"
import { getPostsByTopicUrlName } from "@/app/api/post/postAPI"

function PostList({ initialPosts = [], initialHasNext = false, initialTotalElements = 0, urlName = "" }) {
    const [posts, setPosts] = useState(initialPosts || []);
    const [currentPage, setCurrentPage] = useState(0);
    const [hasNext, setHasNext] = useState(initialHasNext);
    const [totalElements, setTotalElements] = useState(initialTotalElements);
    const [isLoading, setIsLoading] = useState(false);

    const handleLoadMore = async () => {
        setIsLoading(true);
        const nextPage = currentPage + NEXT_PAGE_NUMBER;

        try {
            const response = await getPostsByTopicUrlName(urlName, nextPage);
            const newData = response?.data?.data;


            if (newData) {
                setPosts((prev) => [...prev, ...newData.content]);
                setHasNext(newData.hasNext);
                setTotalElements(newData.totalElements);
                setCurrentPage(nextPage);
            }
        } catch (error) {
            console.error("Error fetching more posts:", error);
        } finally {
            setIsLoading(false);
        }
    };

    if (posts?.length === 0) {
        return (
            <div className="container-fluid block-content mt-2">
                <p className="text-center">Chưa có bài viết nào.</p>
            </div>
        );
    }

    return (
        <div className="container-fluid block-content mt-2">
            <div className='row our-services'>
                {posts?.map((post, index) => {
                    const safeKey = post?.id || post?.slug || post?.urlName || `price-auto-${index}`;
                    return (
                        <div
                            key={safeKey}
                            className="col-ms-6 col-md-4 col-lg-4 wow zoomIn"
                            data-wow-delay="0.1s"
                        >
                            <Link className="block-cus pt-0 mb-5" href={post?.urlName || "#"}>
                                <span className="-mt-5">
                                    <i className={post?.icon} style={{ zoom: "300%" }} aria-hidden="true"/>
                                </span>
                                <div className="mt-5 font-bold fs-5">
                                    {post?.name}
                                </div>
                                <p className="pb-0">{post?.description}</p>
                            </Link>
                        </div>
                    );
                })}
            </div>

            <Paging
                onLoadMore={handleLoadMore}
                totalElements={totalElements}
                hasNext={hasNext}
                data={posts}
                isLoading={isLoading}
            />
        </div>
    );
}


export default PostList